









import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

interface ComboItem {
  text: string;
  value: string;
}

const items: ComboItem[] = [
  { value: "", text: "" },
  { value: "1", text: "Em Processo" },
  { value: "2", text: "Qualificado" },
  { value: "3", text: "Ganho" },
  { value: "4", text: "Perda" },
  { value: "8", text: "Já Cadastrado" },
  { value: "9", text: "Erro" },
];

@Component
export default class ComboStatusLead extends Vue {
  @Prop() readonly value!: string | null;
  @Prop({ required: false, default: false, type: Boolean })
  readonly allStatus!: boolean;
  @Prop({ required: false, default: false, type: Boolean })
  readonly novoLead!: boolean;
  etapaLead: ComboItem | null = null;
  get items() {
    if (!this.allStatus) {
      if (this.novoLead) {
        return items.filter(
          (x) => ["3", "4", "8", "9"].findIndex((y) => y == x.value) == -1
        );
      } 
      return items.filter(
        (x) => ["8", "9"].findIndex((y) => y == x.value) == -1
      );
    }
    else {
      return items;
    }
  }

  @Prop({ required: true }) readonly label!: string;
  @Prop({ default: () => [] }) readonly rules!: Array<
    (v: any) => string | undefined
  >;

  @Watch("value", { immediate: true })
  onValueChange(val: string | null) {
    val = "" + val;
    this.etapaLead = this.items.find((x) => x.value == val) ?? null;
  }

  @Watch("etapaLead")
  onChangeTipo(val: ComboItem) {
    this.$emit("input", val?.value);
  }
}
